import { generateError, createError } from "../utilities/utils";
import APIManager from "./../utilities/apimanager";
import CookieManager from "./../utilities/cookiemanager";

const authenticationErrors = [
  "E3",
  "E5",
  "E6",
  "E7",
  "E17",
  "E20",
  "E21",
  "E26",
];

export function requestDownload({
  sessionManager,
  paymentMethod,
  contentPackageId,
  subsId,
  orderId,
  confirmDownload,
}) {
  // when requesting a new download we need to clean the old download
  CookieManager.removeCookie(CookieManager.cookieKeys.READER_SESSION);
  return sessionManager.getSessionInfo().then((sessionId) => {
    return APIManager.requestDownload(
      sessionManager.userId,
      sessionId,
      subsId,
      contentPackageId,
      orderId,
      paymentMethod
    )
      .then((downloadData) => {
        if (
          downloadData.StatusMessage.toLowerCase() != "ok" ||
          downloadData.DownloadStatus.toLowerCase() === "refused"
        ) {
          downloadData.call = "requestDownload";
          downloadData.errorType = _setErrorType(downloadData.StatusMessage);
          const error = generateError(downloadData);
          return Promise.reject(error);
        }

        setReaderSession({
          userId: sessionManager.userId,
          sessionId,
          subscriptionId: subsId,
          orderId: downloadData.OrderID,
          downloadId: downloadData.DownloadID,
          cpId: contentPackageId,
        });
        if (!confirmDownload) return Promise.resolve();
        return APIManager.confirmDownload({
          userId: sessionManager.userId,
          sessionId,
          contentPackageId,
          downloadId: downloadData.DownloadID,
          downloadStatus: downloadData.DownloadStatus,
        })
          .then(() => {
            return Promise.resolve();
          })
          .catch((confirmData) => {
            const error = createError(
              "CD-ERR",
              "ConfirmDownload failed",
              confirmData
            );
            return Promise.reject(error);
          });
      })
      .catch((errorData) => {
        //const error = createError('RD-ERR', 'RequestDownload failed', errorData);
        return Promise.reject(errorData);
      });
  });
}

/**
 * Sets the reader session cookie
 */
export function setReaderSession({
  userId,
  sessionId,
  subscriptionId,
  orderId,
  downloadId,
  cpId,
}) {
  const date = new Date();
  const expires = date.setTime(date.getTime() + 1000 * 60 * 60 * 2);
  const info = {
    userId,
    sessionId,
    subsId: subscriptionId,
    orderId,
    downloadId,
    cpId,
    expires,
  };
  CookieManager.createCookie(
    CookieManager.cookieKeys.READER_SESSION,
    JSON.stringify(info),
    {
      expires: 1000 * 60 * 60 * 2,
      path: "/",
      useTime: true,
    }
  );
}

export function resetReaderSession(cookieManager, cookie) {
  if (cookie) {
    const expires = JSON.parse(cookie).expires;
    cookieManager.createCookie(
      cookieManager.cookieKeys.READER_SESSION,
      cookie,
      {
        expires,
        path: "/",
        useExpires: true,
      }
    );
  }
}

/**
 * Checks if the reader session cookie exists
 * @param {*} publicationData
 */
export function checkReaderSession(publicationData, cookieManager) {
  const cookie = cookieManager.getCookie(
    cookieManager.cookieKeys.READER_SESSION
  );
  if (cookie) {
    const json = JSON.parse(cookie);
    if (json) {
      if (
        json.cpId &&
        json.cpId.toString() === publicationData.contentPackageId.toString()
      ) {
        //check if its expired
        const now = new Date();
        return now.getTime() <= json.expires;
      }
    }
  }
  return false;
}

/**
 * This method identifies the type of error authentication or authorization
 * @param {*} errorCode -  backend code of the error E1,E5...
 */
function _setErrorType(errorCode) {
  const errorType = authenticationErrors.some((code) => code === errorCode)
    ? "authentication"
    : "authorization";

  return errorType;
}



// WEBPACK FOOTER //
// ./src/common/subscriptionmanagement/subscriptionUtilities.js